import intl from 'preact-i18n';
import definition from './intl.json';

function intlWrap(c) { return intl(c, { scope: 'finance-components', definition }); }

//it's necessary to do explicit named import/export so that webpack can do proper static analysis

import _AnalystsPanel from './components/analysts-panel';
export const AnalystsPanel = intlWrap(_AnalystsPanel);

import _Currencies from './components/currencies';
export const Currencies = intlWrap(_Currencies);

import { CurrencyIndicator as _CurrencyIndicator } from './components/currency-indicator';
export const CurrencyIndicator = intlWrap(_CurrencyIndicator);

import _CurrencyMatrix from './components/currency-matrix';
export const CurrencyMatrix = intlWrap(_CurrencyMatrix);

import _DynamicStockChart from './components/dynamic-stock-chart';
export const DynamicStockChart = intlWrap(_DynamicStockChart);

import _Earnings from './components/statistics-panel/earnings';
export const Earnings = intlWrap(_Earnings);

import _FinancialDetailsPanel from './components/financial-details-panel';
export const FinancialDetailsPanel = intlWrap(_FinancialDetailsPanel);

import _FundsPanel from './components/funds-panel';
export const FundsPanel = intlWrap(_FundsPanel);

import _HistoricalDataPanel from './components/historical-data-panel';
export const HistoricalDataPanel = intlWrap(_HistoricalDataPanel);

import _HoldingsPanel from './components/holdings-panel';
export const HoldingsPanel = intlWrap(_HoldingsPanel);

import _IncomeStatement from './components/stock-data-table/income-statement';
export const IncomeStatement = intlWrap(_IncomeStatement);

import _MarketIndicators from './components/market-indicators';
export const MarketIndicators = intlWrap(_MarketIndicators);

import _MarketsPanel from './components/markets-panel';
export const MarketsPanel = intlWrap(_MarketsPanel);

import _PressWidget from './components/press-widget';
export const PressWidget = intlWrap(_PressWidget);

import _Profile, { ProfilePhone as _ProfilePhone } from './components/company-profile';
export const Profile = intlWrap(_Profile);
export const ProfilePhone = intlWrap(_ProfilePhone);


import _RecentlyViewed from './components/stock-recently-viewed';
export const RecentlyViewed = intlWrap(_RecentlyViewed);

import _SectorPerformance from './components/sector-performance';
export const SectorPerformance = intlWrap(_SectorPerformance);

import _SectorsPanel from './components/sectors-panel';
export const SectorsPanel = intlWrap(_SectorsPanel);

import _Statistics from './components/statistics-panel';
export const Statistics = intlWrap(_Statistics);

import _StockChartDetails from './components/stock-chart-details';
export const StockChartDetails = intlWrap(_StockChartDetails);

import _StockDetailsPage from './components/stock-details-page';
export const StockDetailsPage = intlWrap(_StockDetailsPage);

import _StockList from './components/stock-list';
export const StockList = intlWrap(_StockList);

import _StockOpenAnalysis from './components/stock-open-analysis';
export const StockOpenAnalysis = intlWrap(_StockOpenAnalysis);

import { StockPerformanceByDay as _StockPerformanceByDay, StockPerformanceByMonth as _StockPerformanceByMonth } from './components/stock-performance';
export const StockPerformanceByDay = intlWrap(_StockPerformanceByDay);
export const StockPerformanceByMonth = intlWrap(_StockPerformanceByMonth);

import _StockPriceBar from './components/stock-price-bar';
export const StockPriceBar = intlWrap(_StockPriceBar);

import _StockQuotePanel from './components/stock-quote-panel';
export const StockQuotePanel = intlWrap(_StockQuotePanel);

import _StocksPanel from './components/stocks-panel';
export const StocksPanel = intlWrap(_StocksPanel);

import _StocksWidget from './components/stocks-widget';
export const StocksWidget = intlWrap(_StocksWidget);

import _StockSymbolTable from './components/stock-symbol-table';
export const StockSymbolTable = intlWrap(_StockSymbolTable);

import _StockTickerBar from './components/stock-ticker-bar';
export const StockTickerBar = intlWrap(_StockTickerBar);

import _WorldMarkets from './components/world-markets';
export const WorldMarkets = intlWrap(_WorldMarkets);

import _SymbolLookupWidget from './components/symbol-lookup-widget';
export const SymbolLookupWidget = intlWrap(_SymbolLookupWidget);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/index.js